var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.htmlElements)?_c('div',_vm._l((_vm.htmlElements),function(html,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(html)}})}),0):_c('span',[_vm._v("redirect...")])}
var staticRenderFns = []

export { render, staticRenderFns }